import React, { useEffect, useState } from "react";
import "./recruiters.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const Recruiters = () => {
  const [recruiters, setRecruiters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchRecruiters = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/top-recruiters/public`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Failed to load recruiters");
        setRecruiters(data.recruiters || []);
      } catch (err) {
        setError(err.message || "Failed to load recruiters");
      } finally {
        setLoading(false);
      }
    };
    fetchRecruiters();
  }, []);

  return (
    <div className="recruiters-wrapper">
      <h1 className="title">Our Top Recruiters</h1>
      <hr />
      <p>
        Our graduates are recruited by leading companies across various industries.
      </p>

      {loading && <p className="loading-text">Loading recruiters...</p>}
      {error && <p className="error-text">{error}</p>}

      {!loading && !error && recruiters.length > 0 && (
        <div className="recruiters-logos">
          {recruiters.map((recruiter) =>
            recruiter.logo_path ? (
              <img
                key={recruiter.id}
                src={`${API_BASE}${recruiter.logo_path}`}
                alt={recruiter.company_name}
                className="recruiter-logo"
              />
            ) : null
          )}
        </div>
      )}
    </div>
  );
};

export default Recruiters;
